module.exports = __webpack_public_path__ + "e8553e56d28ecd2592bcbb20f4702404.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/image_vid_H_1100px.jpg
// module id = 390
// module chunks = 0